export default __webpack_public_path__ + "static/media/وحید کریمی.fa0f8a2b.jpeg";